import { TagModel } from '@app/types/TagModel'
import { useClient, useQuery } from '@based/sdk/react'
import { useCallback, useMemo } from 'react'
import { TagSelectionGroup } from '../shared/TagSelectionGroup'
import { useEditContainerClose } from '../shared/useEditContainerClose'

export type TargetGroupsEditProps = {
  initiativeId: number
  selectedTags: number[]
}

export const TargetGroupsEdit = ({
  initiativeId,
  selectedTags,
}: TargetGroupsEditProps) => {
  const closeFromContainer = useEditContainerClose()
  const onClose = closeFromContainer ?? undefined
  if (!onClose) {
    throw new Error(
      'TargetGroupsEdit requires `onClose` or an `EditContainer` ancestor',
    )
  }

  const client = useClient()

  const targetGroupsQuery = useQuery('list-target-groups')

  const allTags: TagModel<number>[] = useMemo(
    () =>
      (targetGroupsQuery.data ?? []).map(
        (item: { id: number; name: string }) => ({
          key: item.id,
          value: item.name,
        }),
      ),
    [targetGroupsQuery.data],
  )

  const saveTargetGroups = useCallback(
    (selectedIds: number[]): Promise<boolean> =>
      client.call('edit-initiative', {
        id: initiativeId,
        value: {
          targetAudiences: selectedIds.map((id) => ({ id })),
        },
      }),
    [client, initiativeId],
  )

  return (
    <TagSelectionGroup
      allTags={allTags}
      selectedIds={selectedTags}
      onClose={onClose}
      onSave={saveTargetGroups}
    />
  )
}
